/**
 * Shared helpers so list pages never hang forever on loading.
 * Pair with apiClient timeout (AllApi.js) and always clear loading in finally.
 */

export const isAbortError = (error) =>
  error?.code === "ERR_CANCELED" ||
  error?.name === "CanceledError" ||
  error?.name === "AbortError";

/** Create a request guard: abort previous call, ignore stale responses. */
export const createRequestGuard = () => {
  let controller = null;
  let generation = 0;

  return {
    next() {
      if (controller) controller.abort();
      controller = new AbortController();
      const myGen = ++generation;
      return {
        signal: controller.signal,
        isCurrent: () => myGen === generation,
      };
    },
    abort() {
      if (controller) controller.abort();
      generation += 1;
      controller = null;
    },
  };
};
